"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const NoSongwritersMessage_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneSongwriterTab/NoSongwritersMessage"));
const SongwriterAccountCards_1 = __importDefault(require("@Components/Cards/AccountCard/SongwriterAccountCards"));
const ProfileSceneSongwriterTab = () => {
    const limitItems = 6;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { songwriterSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const allSongwriters = songwriterSearchStore.songwriters;
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        songwriterSearchStore.loadSongwriters({ page: 1, limit: limitItems }).finally(() => {
            setLoading(false);
        });
    }, []);
    return loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : allSongwriters.totalElements === 0 ? (react_1.default.createElement(NoSongwritersMessage_1.default, null)) : (react_1.default.createElement("div", { className: 'profile-scene-songwriter-tab' },
        react_1.default.createElement("div", { className: 'songwriter-profile-top-section' },
            react_1.default.createElement("p", null,
                allSongwriters.totalElements,
                " ",
                'Songwriter Accounts'),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: common_1.ICONS.add, onClick: () => navigate(navigation_1.default.registrationSongwriter.root()) }, "Add a Songwriter")),
        react_1.default.createElement(SongwriterAccountCards_1.default, { allSongwriters: allSongwriters }),
        allSongwriters && allSongwriters.totalElements > limitItems && (react_1.default.createElement(Pagination_1.default, { limit: limitItems, paginationPages: songwriterSearchStore.paginationInfo, onChange: (pagination) => songwriterSearchStore.loadSongwriters(pagination) }))));
};
exports.default = ProfileSceneSongwriterTab;
